"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const globals_1 = require("../../infra/globals");
const router_1 = require("../../routing/router");
const date_utils_1 = require("../../infra/date_utils");
const ui_table_1 = __importDefault(require("./ui_table"));
const utils_1 = require("../../infra/utils");
class GameEventsTable extends ui_table_1.default {
    gameEventNameSearch;
    static tag = "game-events-table";
    getAllGameEvents = async () => {
        await this.firestoreQuery((0, firestore_1.query)((0, firestore_1.collection)(globals_1.db, "game_events"), (0, firestore_1.orderBy)("firstDate", "desc"), (0, firestore_1.startAfter)(this.lastVisible), (0, firestore_1.limit)(globals_1.queryLimit)));
    };
    getGameEventNameSearch = async () => {
        await this.firestoreQuery((0, firestore_1.query)((0, firestore_1.collection)(globals_1.db, "game_events"), (0, firestore_1.where)("searchableName", "array-contains", this.gameEventNameSearch.toLowerCase()), (0, firestore_1.orderBy)("name", "desc"), (0, firestore_1.startAfter)(this.lastVisible), (0, firestore_1.limit)(globals_1.queryLimit)));
    };
    getData = async () => {
        try {
            if (this.gameEventNameSearch)
                await this.getGameEventNameSearch();
            else
                await this.getAllGameEvents();
        }
        catch (e) {
            const error = e;
            (0, utils_1.tableErrorLog)(error, "Game Events' Table");
        }
    };
    constructor(title = "Eventos", gameEventNameSearch = "") {
        super(title);
        this.gameEventNameSearch = gameEventNameSearch;
    }
    get caption() {
        return `
      <h2>
        <route-link href="${router_1.RouteEnum.gameEvents}">
          ${this.title}
        </route-link>
      </h2>
    `;
    }
    get legend() {
        return `
      <span>#</span>
      <span class="align-left">Nome</span>
      <span>Tipo</span>
      <span class="non-mobile">Total de Partidas</span>
      <span>Data de Início</span>
      <span class="non-mobile">Data de Fim</span>
    `;
    }
    setCards = () => {
        const cardsDiv = this.querySelector("#cards");
        const length = this.data.length;
        for (let i = this.startAfter; i < length; i++) {
            const gameEvent = this.data[i];
            const firstDate = gameEvent.dates.length === 0
                ? globals_1.emdash
                : date_utils_1.DateUtils.formatDate(new Date(gameEvent.dates[0]));
            const lastDate = gameEvent.dates.length === 1
                ? globals_1.emdash
                : date_utils_1.DateUtils.formatDate(new Date(gameEvent.dates[gameEvent.dates.length - 1]));
            cardsDiv.innerHTML += `
        <route-link
          class="card"
          id="${gameEvent.firebaseRef}"
          href="${router_1.RouteEnum.gameEvents}/${gameEvent.firebaseRef}">
            <span>${i + 1}</span>

            <route-link 
              href="${router_1.RouteEnum.gameEvents}/${gameEvent.firebaseRef}">
                <span class="align-left">${gameEvent.name}</span>
            </route-link>
            
            <span>${gameEvent.type}</span>
            
            <span class="non-mobile">${gameEvent.gamesTotal}</span>
            
            <span>${firstDate}</span>

            <span class="non-mobile">${lastDate}</span>
        </route-link>
      `;
        }
    };
}
exports.default = GameEventsTable;
//# sourceMappingURL=data:application/json;base64,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